export enum AppTemplates {
  main = 'main',
  blank = 'blank'
}
